/*
* Project: LegalPlace assistant
* File: src/components/buy/popover.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setAppState, LP_STATE_CHECKOUT } from '../../redux/actions/app_state';
import { hidePopover } from '../../redux/actions/toggle_preview';
import { _lp } from '../../logic/wording';

class _PopOver extends Component {
  constructor(props) {
    super(props);
    this.goToDownload1 = this.goToDownload1.bind(this);
  }

  componentDidMount() {
    document.getElementById('modal').appendChild(this.refs.modal_download);
    document.body.classList.add('overflow-hidden');
    document.getElementsByClassName('page-wrap')[0].classList.add('unfocus');
  }

  componentDidUpdate() {
    document.getElementById('modal').appendChild(this.refs.modal_download);
    document.body.classList.add('overflow-hidden');
    document.getElementsByClassName('page-wrap')[0].classList.add('unfocus');
  }

  componentWillUnmount() {
    document.body.classList.remove('overflow-hidden');
    document.getElementsByClassName('page-wrap')[0].classList.remove('unfocus');
    document.getElementById('real-popover').appendChild(this.refs.modal_download);
  }

  goToDownload1() {
    this.props.goBack();
    // saveMail(this.props.mail);
    this.props.goToDownload();
  }

  render() {
    return (
      <div className="lp-modal doc-download-modal" ref="modal_download">
        <div className="container">
          <div onClick={this.props.goBack} className="lpm-close icn-x" />
          <div className="lp-modal-content col-md-6 col-md-offset-3">
            <i className="icn-info-o" />
            <p className="ddm-notice">{_lp("Il est conseillé de remplir le document afin que vous puissiez l'adapter à votre situation")}</p>
            <p>{_lp('Êtes-vous sûr de passer au téléchargement?')}</p>
            <a onClick={this.props.goBack} href="#" className="btn btn-primary btn-lg">
              <i className="icn-pen" />
              {_lp('J’adapte mon document')}
            </a>
            <br />
            <a className="lnk-white hover-pointer" onClick={this.goToDownload1}>{_lp('Je passe au téléchargement')}</a>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  mail: state.account_settings.mail,
});

const mapDispatchToProps = dispatch => ({
  bq: () => { dispatch(setAppState(LP_STATE_CHECKOUT)); },

  back: () => { dispatch(hidePopover()); },
});
const mergeProps = (stateProps, dispatchProps) => ({
  mail: stateProps.mail,
  goToDownload: () => {
    dispatchProps.bq(stateProps.mail);
  },
  goBack: dispatchProps.back,
});
const LpPopOver = connect(mapStateToProps, mapDispatchToProps, mergeProps)(_PopOver);

export default LpPopOver;



// WEBPACK FOOTER //
// ./src/components/buy/popover.js